import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { SeverityPill } from "../../components/Pills";
import { toast } from "sonner";
import { Check } from "lucide-react";

export default function OperatorAlerts() {
  const [alerts, setAlerts] = useState([]);

  const refresh = () => api.get("/alerts").then(({ data }) => setAlerts(data));
  useEffect(() => { refresh(); }, []);

  const ack = async (id) => {
    try {
      await api.post(`/alerts/${id}/acknowledge`);
      toast.success("Acknowledged");
      refresh();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  };

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">INCIDENTS</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Alerts & Maintenance</h1>
      </div>

      <div className="space-y-3">
        {alerts.map((a) => (
          <div key={a.id} data-testid={`alert-${a.id}`} className={`bin-card p-4 flex items-center justify-between ${a.acknowledged ? "opacity-50" : ""}`}>
            <div>
              <div className="flex items-center gap-2 mb-1">
                <SeverityPill severity={a.severity} />
                <span className="text-xs font-mono uppercase text-zinc-500">{a.type}</span>
                <span className="text-xs font-mono text-zinc-600">{new Date(a.created_at).toLocaleString()}</span>
              </div>
              <div className="font-bold">{a.station_name}</div>
              <div className="text-sm text-zinc-400">{a.message}</div>
            </div>
            {!a.acknowledged ? (
              <button data-testid={`alert-ack-${a.id}`} onClick={() => ack(a.id)} className="bin-btn inline-flex items-center gap-2">
                <Check className="w-3.5 h-3.5" /> Acknowledge
              </button>
            ) : (
              <span className="bin-label text-emerald-400">ACKED</span>
            )}
          </div>
        ))}
        {alerts.length === 0 && <div className="bin-card p-8 text-center text-zinc-500">No alerts.</div>}
      </div>
    </div>
  );
}
